import { Button, ButtonProps, Radio as RadioComponent } from 'antd';
import {
    BREAKPOINTS,
    BREAKPOINTS_NUM,
} from 'constants/Global/Breakpoints.const';
import styled, { css } from 'styled-components';

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  border-bottom: 1px solid #f0f0f0;
  max-width: 220px;

  .icon {
    font-size: 24px;
    height: 24px;
    color: #f78e1e;
    padding-right: 4px;
  }
`;

export const ConceptName = styled.span`
  font-weight: 700;
  text-transform: uppercase;
  padding-left: 4px;
`;

export const CtaTitle = styled.div`
  font-family: Roboto;
  font-weight: 700;
  font-style: Bold;
  font-size: 1rem;
  line-height: 100%;
  letter-spacing: 0%;
  padding: 16px 0 8px;
`;

export const TypeSaleInput = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    flex-direction: row;
    padding: 0 8px;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    flex-direction: column;
    justify-content: center;
    flex: 1;
    min-width: 312px;
    max-width: 340px;
    border-left: 1px solid #f0f0f0;
  }
`;

type IButtonProps = {
  isDisabled: boolean;
};

export const TypeSaleContainer = styled.div`
  display: flex;
  padding: 8px;
  min-width: 20%;

  @media (min-width: ${BREAKPOINTS.tabletMini}) and (max-width: ${BREAKPOINTS_NUM.tablet -
    1}px) {
    width: 184px;
  }
`;

export const SaleInputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
`;

export const PriceContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    justify-content: start;
  }
`;

export const PriceLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
  color: #8c8c8c;

  @media (min-width: ${BREAKPOINTS.tabletMini}) and (max-width: ${BREAKPOINTS_NUM.tablet -
    1}px) {
    width: 38px;
    font-size: 0.625rem;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    font-size: 0.875rem;
  }
`;

export const PriceValue = styled.div`
  font-size: 1rem;
  font-weight: 700;
  color: black;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    font-size: 1.25rem;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  @media (max-width: ${BREAKPOINTS_NUM.tablet - 1}px) {
    width: 95%;
  }
`;

export const CheckBoxButton = styled.div<IButtonProps>`
  display: flex;

  .ant-radio-inner {
    border-color: black !important;
  }

  .ant-radio-inner:after {
    border-color: black !important;
  }

  .ant-radio-checked .ant-radio-inner:after {
    background-color: #f78e1e !important;
    border-color: #f78e1e !important;
    color: #f78e1e !important;
    padding: 0;
  }

  .ant-radio-wrapper-checked .ant-radio-inner,
  .ant-radio-wrapper-checked div {
    border-color: #f78e1e !important;
    color: #f78e1e !important;
    padding: 0;
  }

  .ant-radio-checked .ant-radio-inner:after {
    background-color: #f78e1e !important;
    border-color: #f78e1e !important;
    color: #f78e1e !important;
    padding: 0;
  }

  @media (max-width: ${BREAKPOINTS_NUM.tabletMini - 1}px) {
    border-bottom: 1px solid #d9d9d9;
  }

  @media (max-width: ${BREAKPOINTS_NUM.tablet - 1}px) {
    padding: 8px 0;

    &:last-of-type {
      border: 0;
    }
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    align-items: center;
    justify-content: center;
  }

  ${(props: IButtonProps) => {
    if (props.isDisabled) {
      return css`
        cursor: not-allowed;
        opacity: 0.5;
        color: #d9d9d9;

        span {
          color: #d9d9d9;
        }
      `;
    }

    return '';
  }};
`;

export const Radio = styled(RadioComponent)`
  font-family: Roboto;
  font-weight: 400;
  font-size: 0.625rem;
  line-height: 100%;
  letter-spacing: 0%;
  color: black;

  span {
    padding-right: 0;
  }
`;

export const SaleTypePriceContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Roboto;
  font-weight: 400;
  font-size: 0.625rem;
  line-height: 100%;
  letter-spacing: 0%;
  color: black;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    flex-direction: column;
    align-items: start;
    line-height: 1.4;
  }
`;

export const SaleTypePrice = styled.div`
  font-weight: 700;
  font-size: 1rem;
  color: ${({ checked }) => (checked ? '#f78e1e' : 'black')};
`;

export const SaleTypeDivider = styled.div`
  border-right: 1px solid #d9d9d9;
  height: 100%;
  min-height: 16px;
  margin-right: 8px;
`;

export const PriceInputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;

  form {
    width: 100%;

    div {
      margin-bottom: 0;
    }
  }
`;

export const QuantityLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 2px;
  gap: 2px;
  margin-top: 4px;
  font-weight: 400;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 0%;

  .button-composition {
    align-self: center;
  }
`;

export const InfoFirstRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  color: #595959;
`;

export const CompositionLine = styled.div`
  font-size: 10px;
  color: #595959;
`;

export const TotalPedidoLine = styled.div`
  font-size: 10px;
  color: #262626;
  font-weight: 600;
  margin-top: 4px;
  padding: 6px 10px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
`;

export const MinQuantityProduct = styled.div`
  font-weight: 400;
  font-size: 0.625rem;
  color: #595959;
`;

export const ShippingFee = styled.div`
  font-family: Roboto;
  font-weight: 700;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #f78e1e;
  background-color: #fff9eb;
  padding: 2px 2px 1px 2px;
  width: fit-content;
  margin-top: 4px;
  margin-bottom: 4px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 4px;
  padding: 8px;

  @media (max-width: ${BREAKPOINTS_NUM.tabletMini - 1}px) {
    padding-top: 0;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    padding-left: 8px;
    justify-content: end;
  }

  @media (max-width: ${BREAKPOINTS_NUM.tablet - 1}px) {
    flex: 1;
  }
`;

export const BuyButton = styled(Button)<ButtonProps>`
  height: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  min-width: 0;

  &.cart-button {
    border-color: #f78e1e;
    color: #f78e1e;
  }

  @media (max-width: ${BREAKPOINTS_NUM.tabletMini - 1}px) {
    flex: 1;
  }
`;

export const ButtonTooltipWrapper = styled.span<{ isDisabled?: boolean }>`
  display: flex;
  min-width: 0;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'auto')};

  > button {
    width: 100%;
    ${({ isDisabled }) => (isDisabled ? 'pointer-events: none;' : '')}
  }

  @media (max-width: ${BREAKPOINTS_NUM.tabletMini - 1}px) {
    flex: 1;
  }
`;

export const ButtonText = styled.div`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 4px;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    font-size: 0.875rem;
  }
`;
